import { render, staticRenderFns } from "./EditorDeTexto.vue?vue&type=template&id=971d7698&scoped=true"
import script from "./EditorDeTexto.vue?vue&type=script&lang=js"
export * from "./EditorDeTexto.vue?vue&type=script&lang=js"
import style0 from "./EditorDeTexto.vue?vue&type=style&index=0&id=971d7698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d7698",
  null
  
)

export default component.exports